<template>
  <!-- <nav><router-link to="/">Home</router-link></nav> -->
  <v-app id="app">
    <router-view />
  </v-app>
</template>

<style lang="scss"></style>
